/**
 * Which organization the manager dashboard shows after (re)loading the
 * manager's organizations. Mirrors the examiner page: a lone organization
 * opens straight away; with several, nothing opens until the manager picks
 * one — auto-opening the first (e.g. Josour) meant waiting for its whole
 * member list before switching. A current choice survives a refresh, and the
 * manager's last choice (remembered per browser) reopens on the next visit.
 */
export function keepOrPickOrganization<T extends { id: string }>(
  organizations: T[],
  current: T | null,
  rememberedId?: string | null,
): T | null {
  for (const id of [current?.id, rememberedId]) {
    const found = id ? organizations.find((o) => o.id === id) : undefined;
    if (found) return found;
  }
  return organizations.length === 1 ? organizations[0] : null;
}
